"use client";
import clsx from "clsx";
import type { MouseEventHandler, ReactNode } from "react";

type Props = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  size?: "default" | "sm" | "icon";
};
export const ThirdButton = ({ onClick, children, className, type = "button", disabled, size = "default" }: Props) => {
  return (
    <button
      type={type}
      className={clsx(
        "group/btn rounded-lg border relative overflow-hidden transition-colors disabled:grayscale cursor-pointer disabled:cursor-not-allowed",
        "bg-bg-1 border-bg-2 hover:bg-bg-1/30 text-tx-1 stroke-tx-1",
        {
          "h-12 px-6 text-base/5 font-normal": size === "default",
          "h-10 px-3 text-sm font-normal": size === "sm",
          "h-10 w-10": size === "icon",
        },
        className,
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <p
        className={clsx("flex justify-center items-center transition-transform whitespace-nowrap", {
          "gap-2": size === "sm",
          "gap-4": size !== "sm",
        })}
      >
        {children}
      </p>
    </button>
  );
};
